import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar';  // https://github.com/idiotWu/smooth-scrollbar/blob/develop/docs/api.md
import SmoothScroll                   from 'smooth-scroll';     // https://github.com/cferdinandi/smooth-scroll
import { throttle }         from 'lodash';

class InvertDeltaPlugin extends ScrollbarPlugin {
  static pluginName     = 'invertDelta';
  static defaultOptions = {
    events: [],
  };

  transformDelta(delta, fromEvent) {
    if (this.shouldInvertDelta(fromEvent)) {
      return {
        x: delta.y,
        y: 0          //This should be delta.x or 0 if you want to avoid vertical scrolling
      };
    }
    return delta;
  }

  shouldInvertDelta(fromEvent) {
    return this.options.events.some(rule => fromEvent.type.match(rule));
  }
}

Scrollbar.use(InvertDeltaPlugin);



class Scroller {
  constructor(verticalWheelScroll = true) {
    this.element = document.getElementsByClassName('scrollbar-wrapper')[0];

    this.options = {
      damping: 0.25,
      thumbMinSize: 5,
      renderByPixel: true,
      alwaysShowTracks: false,
      continuousScrolling: true
    };

    if (!verticalWheelScroll) {
      this.options.plugins = {
        invertDelta: {
          events: [/wheel/]
        }
      }
    }

    if(!app.device.mobileOrTablet) this.init();
  }


  init(container = document) {
    this.customScroll = true;
    this.element      = container.getElementsByClassName('scrollbar-wrapper')[0];

    if (!!this.element) {
      this.scrollbar = Scrollbar.init(this.element, this.options);
      document.body.setAttribute('data-scroller', true);
    } else {
      document.body.setAttribute('data-scroller', false);
    }
  }


  update() {
    if (!!this.scrollbar) this.scrollbar.update();
  }


  destroyAll() {
    if (!!this.scrollbar) this.scrollbar.update();
  }


  // This must be refactored for other elements
  addListener() {
    const navbar = app.components.navbar;
    const navbarWrapper = app.components.navbar.navbarWrapper;
    
    if(!!this.scrollbar) {
      this.scrollbar.addListener((data) => {
        if (data.offset.y > 80) {
          navbar.compact(false);
          navbarWrapper.classList.add('bg-enabled');
        } else {
          navbar.compact(true);
          navbarWrapper.classList.remove('bg-enabled');
        }
        
        const donuts = document.getElementsByClassName('donut');
        if(donuts) {
          for (let [i,donut] of [...donuts].entries()) {
            if(i === 0) {
              donut.style.top = (data.offset.y * 0.3) + 'px'
            } else if(i === 1) {
              donut.style.top = (data.offset.y * 0.15) + 'px'
            } else if( i === 2) {
              donut.style.top = (data.offset.y * 0.05) + 'px'
            } else if( i === 3) {
              donut.style.top = (data.offset.y * 0.2) + 'px'
            } else if( i === 4) {
              donut.style.top = (data.offset.y * 0.15) + 'px'
            }
          } 
        }
      });
    }
  }


  checkURL() {
    // Scroll to HASH option
    // ---------------------
    const hash = window.location.hash;
    if(!!hash) {
      const id     = hash.substring(1);
      const target = document.getElementById(id);
      setTimeout(() => {
        if(!!target) {
          const targetPosition = app.scroller.getElementPosition(target);

          if(!app.device.mobileOrTablet) {
            // Custom scroll
            app.scroller.scrollbar.scrollTo(0, targetPosition.top, 600);
          } else {
            // Native scroll
            const scroll = new SmoothScroll();
            scroll.animateScroll(targetPosition.top);
          }
        }
      }, 400);
    }
  }


  scrollHasChanged(condition, callback, callbackParams, throttlingValue = 0) {
    this.scrollbar.addListener(_.throttle((data) => {
      if (condition) callback(callbackParams);
    }, throttlingValue));
  }


  restart(container = document, verticalWheelScroll = true) {
    if (this.customScroll) {

      if (verticalWheelScroll) {
        this.options.plugins = {};
      } else {
        this.options.plugins = {
          invertDelta: {
            events: [/wheel/]
          }
        }
      }

      this.element = document.getElementById('scrollbar-wrapper');
      this.init(container);
      this.update();
    }
  }

  elementIsVisible(component, threshold, axis, scrollbarContainer, edgeDistance) {
    const docEl    = document.documentElement,
          element  = component.element,
          viewport = {};

    var scrollbar;
    scrollbarContainer ? scrollbar = scrollbarContainer : scrollbar = this.element;

    viewport.width  = docEl.clientWidth  < window.innerWidth  ? window.innerWidth  : docEl.clientWidth;
    viewport.height = docEl.clientHeight < window.innerHeight ? window.innerHeight : docEl.clientHeight;

    if (this.customScroll) {
      this.scrollbar.addListener((data) => {

        var elementPosition = this.getElementPosition(element, threshold);
        viewport.scrollX = this.scrollbar.offset.x;
        viewport.scrollY = this.scrollbar.offset.y;
        var result;
        axis === 'y' || 'Y' ? result = this.inYAxis(elementPosition, viewport) : result = this.inXAxis(elementPosition, viewport);

        // This line only for parallax.js (needs to be extracted as a callback)
        // IDEA block scroll on all the list minus the active ones
        // new click, scroll to top, block the active one, active the new one
        // debugger;

        result ? component.running = true : component.running = false;
      });
    }
  }


  lockScroll() {
    this.element.classList.add('scroll-locked');
  }


  unlockScroll() {
    this.element.classList.remove('scroll-locked');
  }


  getElementPosition(element, threshold) {
    const oldContainer = (!!app.pjax && !!app.pjax.oldContainerDimensions) ? app.pjax.oldContainerDimensions : { width: 0, height: 0 };

    var calibrate = (ElementCoordinates, threshold = 0) => {
      var element = {
        top    : ElementCoordinates.top - threshold - oldContainer.height,
        bottom : ElementCoordinates.bottom + threshold - oldContainer.height,
        left   : ElementCoordinates.left - threshold - oldContainer.width,
        right  : ElementCoordinates.right + threshold - oldContainer.width
      };

      element.width  = element.right  - element.left;
      element.height = element.bottom - element.top;

      return element;
    };

    return calibrate(element.getBoundingClientRect(), threshold);
  }


  inXAxis(elementPosition, viewport){
    return elementPosition.right >= 0 && elementPosition.left <= viewport.width;
  }


  inYAxis(elementPosition, viewport){
    return elementPosition.bottom >= 0 && elementPosition.top <= viewport.height;
  }


  scrollToTop(){
    if (this.customScroll) {
      this.scrollbar.scrollTop = 0;
    } else {
      window.scrollTo(0,0);
    }
  }

  scrollTo(element) {
    if (this.customScroll) {
      const pos = this.getElementPosition(element);
      app.scroller.scrollbar.scrollTo(0, pos.top, 600);
    } else {
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
  }

  setPosition(){}
}


export default Scroller;
